import React from 'react';
import { FormControl, Switch } from '@mui/material';
import { AutoLogoutContext, AutoLogoutSendEnabledRequestContext } from './auto-logout-notification.context';


export const useDisabledAutoLogoutTillMounted = () => {
  const { enabled } = React.useContext(AutoLogoutContext);
  const sendIsEnabledRequest = React.useContext(AutoLogoutSendEnabledRequestContext);

  React.useEffect(() => {
    if (!enabled) return;

    const interval = setInterval(() => sendIsEnabledRequest(false), 1000);

    return () => {
      clearInterval(interval);
    };
  }, [ enabled ]); // eslint-disable-line react-hooks/exhaustive-deps
};


export const DisabledAutoLogoutTillMounted = () => {
  useDisabledAutoLogoutTillMounted();
  return null;
};


export const DisabledAutoLogoutTillMountedToggle = () => {
  const [ disabled, setDisabled ] = React.useState(false);

  return (
    <>
      <FormControl>
        <Switch checked={!disabled} value={!disabled} onChange={(e, v) => setDisabled(!v)} />
        Autologout
      </FormControl>
      {disabled && <DisabledAutoLogoutTillMounted />}
    </>
  );
};
